/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit DataStaticLabel.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import Label from 'DesignSystem/Label/view.js'
import React from 'react'
import { css } from "emotion"

let styles = {}
styles.Vertical = css({label: 'Vertical',
  userSelect: "text",
flexShrink: 1,
flexBasis: 0,
  flexGrow: 'var(--flexGrow)',
height: 'var(--height)',
marginLeft: 'var(--marginLeft)',
marginTop: 'var(--marginTop)',
paddingBottom: 'var(--paddingBottom)'})
styles.Text = css({label: 'Text',
  fontFamily: "WonderUnitSans",
fontSize: 14,
letterSpacing: 0.3,
hyphens: "none",
  color: 'var(--color)',
fontWeight: 'var(--fontWeight)',
textTransform: 'var(--textTransform)'})

export default function DataStaticLabel({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  goTo,
flexGrow= 1,
height= 50,
marginLeft= 0,
marginTop= 0,
paddingBottom= 0,
label,
marginBottomLabel= 10,
text,
color= "#303030",
fontWeight= 400,
textTransform= "none"
}) {
    
    
    
    
    
    

  return (<React.Fragment
>
<a
 href={goTo} rel='noopener noreferrer' target='_blank'
 data-testid="DataStaticLabel.Vertical"
 data-view-path={dataViewPath}
 style={{'--flexGrow': flexGrow,'--height': typeof height === 'number' ? `${height}px` : height,'--marginLeft': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--marginTop': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--paddingBottom': typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom}}
 className={`views-block ${styles.Vertical}`}
>
<Label
 data-testid="DataStaticLabel.Label"
 data-view-path={dataViewPath}
 text={label}
 marginBottom={marginBottomLabel}
/>
<span
 data-testid="DataStaticLabel.Text"
 data-view-path={dataViewPath}
 style={{'--color': color,'--fontWeight': fontWeight,'--textTransform': textTransform}}
 className={`views-text ${styles.Text}`}
>
{!text ? "-" : text}
</span>
</a>
{children}
</React.Fragment>)
}